export { default as PatientJourneyView } from './PatientJourneyView';
